module.exports = __webpack_public_path__ + "img/keji.dcbe4a4f.png";